import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5001/api';

export interface Milestone {
  id: string;
  project_id: string;
  milestone_date: string;
  description: string;
  is_active: boolean;
  created_by: string;
  created_by_name?: string;
  created_at: string;
  updated_at: string;
}

export interface CreateMilestoneInput {
  milestone_date: string;
  description: string;
}

export interface UpdateMilestoneInput {
  milestone_date?: string;
  description?: string;
}

export async function listMilestones(projectId: string, token: string): Promise<Milestone[]> {
  const response = await axios.get(
    `${API_BASE_URL}/projects/${projectId}/milestones`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data.data;
}

export async function createMilestone(projectId: string, input: CreateMilestoneInput, token: string): Promise<Milestone> {
  const response = await axios.post(
    `${API_BASE_URL}/projects/${projectId}/milestones`,
    input,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data.data;
}

export async function updateMilestone(projectId: string, milestoneId: string, input: UpdateMilestoneInput, token: string): Promise<Milestone> {
  const response = await axios.put(
    `${API_BASE_URL}/projects/${projectId}/milestones/${milestoneId}`,
    input,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data.data;
}

export async function deleteMilestone(projectId: string, milestoneId: string, token: string): Promise<void> {
  await axios.delete(
    `${API_BASE_URL}/projects/${projectId}/milestones/${milestoneId}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
}
